/* src/app/forms/query-executor/query-executor-popup-dialog.component.scss */
.popup-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 10px;
}
.popup-container-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  gap: 10px;
  padding: 20px;
  width: 100%;
}
.dialog-title {
  font-size: var(--tem-fs-xl);
  font-weight: 600;
  color: var(--tem-ink);
  margin: 0 0 var(--tem-space-2) 0;
}
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: var(--tem-space-2);
}
.example-full-width {
  width: 100%;
}
.hdivider {
  margin: 4px 0;
}
.textarea-min-height {
  min-height: 100px;
}
/*# sourceMappingURL=query-executor-popup-dialog.component.css.map */
